import { render, staticRenderFns } from "./NoteConfig.vue?vue&type=template&id=3465c52b&scoped=true"
import script from "./NoteConfig.vue?vue&type=script&lang=js"
export * from "./NoteConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465c52b",
  null
  
)

export default component.exports